import queryString from 'query-string';
import service from '../utility/service';
import { errorOccurred } from '../errors/reducer';



const INITIAL_STATE = {
  fetching: false,
  appInitialised:false, 
  type: '',
  records: [],
  lastPage: 0,
  endOfList: false,
  filterQuerystring: ''
};

const types = {
  CLEAR_RECORDS: 'orb/recordList/CLEAR_RECORDS',
  FETCHING_RECORDS: 'orb/recordList/FETCHING_RECORDS',
  RECEIVED_RECORDS: 'orb/recordList/RECEIVED_RECORDS',
  UPDATED_RECORD: 'orb/recordList/UPDATED_RECORD',
  DELETED_RECORD: 'orb/recodList/DELETED_RECORD',
  SET_DISPLAY_FILTER: 'orb/recordList/SET_DISPLAY_FILTER',
  FETCH_FAILED: 'orb/recordList/FETCH_FAILED',
  UPDATE_FILTER_QUERY: 'orb/recordList/UPDATE_FILTER_QUERY',
  APP_INITIALISED: 'orb/APP_INITIALISED'

};

const apiPaths = {
  rfq: 'RFQs',
  order: 'Orders'
};
const idProperties = {
  rfq: 'RFQNumber',
  order: 'OrderNumber'
};
const queryIDs = {
  rfq: 'rfqNum',
  order: 'orderNum'
};

const PAGE_SIZE = 20;

export default function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case types.CLEAR_RECORDS:
      return Object.assign({}, state, {
        records: [],
        lastPage: 0,
        endOfList: false
      });
    case types.FETCHING_RECORDS:
      return Object.assign({}, state, {
        fetching: true,
        appInitialised:false,
      });
      case types.APP_INITIALISED:
        return Object.assign({}, state, {
          appInitialised: true
        })
    case types.RECEIVED_RECORDS:
      return Object.assign({}, state, {
        fetching: false,
        appInitialised: true,
        type: action.recordType,
        records: state.records.concat(action.records),
        lastPage: action.page,
        endOfList: action.endOfList
      });
    case types.UPDATED_RECORD:
      // Replace the record in the list by its id
      return Object.assign({}, state, {
        records: addOrReplaceSummary(state.type, state.records, action.summary)
      });
    case types.DELETED_RECORD:
      // Remove the record from the list by its id
      return Object.assign({}, state, {
        records: removeSummary(state.type, state.records, action.id)
      });
    case types.FETCH_FAILED:
      return Object.assign({}, state, {
        fetching: false,
        endOfList: true
      });
    case types.UPDATE_FILTER_QUERY:
      return Object.assign({}, state, {
        filterQuerystring: action.filterQuerystring
      });
    default:
      return state;
  }
}
reducer.types = types;
reducer.initialState = INITIAL_STATE;
reducer.pageSize = PAGE_SIZE;
reducer.idProperties = idProperties;
reducer.queryIDs = queryIDs;

function addOrReplaceSummary(type, list, summary) {
  const idProperty = idProperties[type];
  const index = list.findIndex(r => r[idProperty] === summary[idProperty]);

  const cloneList = [].concat(list);
  if (index !== -1) {
    // replace existing record
    cloneList.splice(index, 1, summary);
  } else {
    // add new record to front
    cloneList.splice(0, 0, summary);
  }
  return cloneList;
}

function removeSummary(type, list, id) {
  const idProperty = idProperties[type];
  const index = list.findIndex(r => r[idProperty] === id);

  const cloneList = [].concat(list);
  cloneList.splice(index, 1);

  return cloneList;
}

function clearRecords(keepCurrentRecord = false) {
  return {
    type: types.CLEAR_RECORDS,
    keepCurrentRecord
  };
}

//PBI 8375092 Action to track the initialised state
export function appInitialised() {
  return { type: types.APP_INITIALISED
  };
}
//

export function fetchRecords() {
  return { type: types.FETCHING_RECORDS
   };
}

function receivedRecords(recordType, records, page) {
  return {
    type: types.RECEIVED_RECORDS,
    recordType,
    records,
    page,
    endOfList: records.length < PAGE_SIZE
  };
}

function fetchFailed() {
  return {
    type: types.FETCH_FAILED
  };
}

function shouldFetchRecords(state, type, filterQuerystring) {
  if (filterQuerystring !== state.filterQuerystring) {
    return true;
  }
  return type && !state.fetching
    && (state.type !== type || (!state.endOfList && !state.records.length));
}

export function fetchRecordsIfNeeded(type, filterQuerystring = '') {
  return (dispatch, getState) => {
    const state = getState().recordList;
    if (shouldFetchRecords(state, type, filterQuerystring)) {

      if (state.type !== type) {
        dispatch(clearRecords(false));
      }
      if (state.filterQuerystring !== filterQuerystring) {
        dispatch(clearRecords(true));
        dispatch(updateFilterQueryString(filterQuerystring));
      }

      return fetchPage(dispatch, type, 0, filterQuerystring);
    }
    // Nothing to wait for
    return Promise.resolve();
  };
}

function canFetchMore(state, type) {
  return !state.fetching
    && state.type === type
    && state.records.length
    && !state.endOfList;
}

export function fetchMoreRecords(type) {
  return (dispatch, getState) => {
    const state = getState().recordList;
    if (canFetchMore(state, type)) {
      return fetchPage(dispatch, type, state.lastPage + 1, state.filterQuerystring);
    }
    // Nothing to wait for
    return Promise.resolve();
  };
}

function fetchPage(dispatch, type, page, filterQuerystring) {
  dispatch(fetchRecords()); //PBI 8375092 : signal record retrieval in-progress
  // Build the query string for the api for filters and pages
  const queryObj = queryString.parse(filterQuerystring);
  queryObj.pageNumber = page + 1;
  queryObj.pageSize = PAGE_SIZE;
  const query = queryString.stringify(queryObj);
 
  return service.get(`/${apiPaths[type]}?${query}`).then((response) => {

    dispatch(receivedRecords(type, response.data, page));
    dispatch(appInitialised())      //PBI 8375092 : signal record retrieval complete
  }).catch((err) => {
    dispatch(errorOccurred(err, `Getting ${type} records for page ${page + 1}`));
    dispatch(fetchFailed());
  });
}

function updateFilterQueryString(filterQuerystring) {
  return {
    type: types.UPDATE_FILTER_QUERY,
    filterQuerystring
  };
}

export function updateRecordSummary(summary) {
  return {
    type: types.UPDATED_RECORD,
    summary
  };
}

export function updatedRecord(type, id) {
  return dispatch => service.get(`/${apiPaths[type]}?${queryIDs[type]}=${id}`).then((response) => {
    const summaries = response.data;
    if (summaries && summaries.length > 0) {
      dispatch(updateRecordSummary(summaries[0]));
    }
  }).catch((err) => {
    dispatch(errorOccurred(err, `Getting ${type} summary for id ${id}`));
  });
}

export function deletedRecord(type, id) {
  return {
    type: types.DELETED_RECORD,
    id
  };
}




// WEBPACK FOOTER //
// ./src/recordList/reducer.js